import ReportIntro from '@app/components/reports/components/report-intro';
import { useGetReportTags } from '@app/components/reports/utils';
import { OperationReportTypeEnum } from '@shared/api/types';
import { usePurchaseReportResult } from '../purchase-report-result-context';

export default function PurchaseReportIntro() {
  const { result, downloadMode } = usePurchaseReportResult();
  const tags = useGetReportTags(result);

  return (
    <ReportIntro
      reportType={OperationReportTypeEnum.purchase}
      result={result}
      downloadMode={downloadMode}
      tags={tags}
    />
  );
}
